// 안내 기간은 TOOLKIT_POLICY.md의 Asia/Seoul 달력 기준을 따른다.
const SEOUL_OFFSET = 9 * 60 * 60 * 1000;

export const getNoticeEndAt = (notice) => {
    if (notice.endAt) return new Date(notice.endAt);
    const endAt = new Date(new Date(notice.startAt).getTime() + SEOUL_OFFSET);
    endAt.setUTCMonth(endAt.getUTCMonth() + 2);
    return new Date(endAt.getTime() - SEOUL_OFFSET);
};

export const shouldShowNotice = (notice, now = new Date()) => {
    if (!(now >= new Date(notice.startAt) && now < getNoticeEndAt(notice))) return false;
    try {
        const keys = [`${notice.id}:dismissed`, ...(notice.legacyDismissedKeys || [])];
        return !keys.some((key) => localStorage.getItem(key) === 'true');
    } catch (_) {
        return true;
    }
};

export const dismissNotice = (notice) => {
    try {
        localStorage.setItem(`${notice.id}:dismissed`, 'true');
    } catch (_) {
        // 저장소가 제한된 경우 현재 화면의 닫힘 상태는 호출부에서 유지한다.
    }
};